import { DAY_SURGERY_JOURNEY_EXPLANATION } from '../data/daySurgeryJourneyExplanation.js';
import { DIAGNOSTIC_JOURNEY_EXPLANATIONS } from '../data/diagnosticJourneyExplanations.js';
import { ED_STAGE_EXPLANATIONS } from '../data/emergencyDepartmentJourneyExplanation.js';
import { JOURNEY_BATCH3_EXPLANATIONS } from '../data/journeyBatch3Explanations.js';
import { JOURNEY_BATCH4_EXPLANATIONS } from '../data/journeyBatch4Explanations.js';
import { JOURNEY_BATCH5_EXPLANATIONS } from '../data/journeyBatch5Explanations.js';
import { JOURNEY_BATCH6_EXPLANATIONS } from '../data/journeyBatch6Explanations.js';
import { JOURNEY_BATCH7_EXPLANATIONS } from '../data/journeyBatch7Explanations.js';
import { JOURNEY_BATCH8_EXPLANATIONS } from '../data/journeyBatch8Explanations.js';
import { getJourneyExplanationTranslation } from '../data/journeyExplanationTranslations/index.js';
import { MATERNITY_STAGE_EXPLANATIONS } from '../data/maternityJourneyExplanation.js';

export const JOURNEY_EXPLANATION_NAMESPACE = 'journeyExplanation';
const CONTENT_AREA = 'hospital_journeys';
const SOURCES = Object.freeze({
  maternity: MATERNITY_STAGE_EXPLANATIONS,
  'emergency-department': ED_STAGE_EXPLANATIONS,
  mri: DIAGNOSTIC_JOURNEY_EXPLANATIONS.mri,
  ct: DIAGNOSTIC_JOURNEY_EXPLANATIONS.ct,
  ultrasound: DIAGNOSTIC_JOURNEY_EXPLANATIONS.ultrasound,
  'day-surgery': DAY_SURGERY_JOURNEY_EXPLANATION,
  outpatients: JOURNEY_BATCH3_EXPLANATIONS.outpatients,
  'inpatient-ward': JOURNEY_BATCH3_EXPLANATIONS['inpatient-ward'],
  'surgery-operation': JOURNEY_BATCH3_EXPLANATIONS['surgery-operation'],
  'critical-care-visitor': JOURNEY_BATCH3_EXPLANATIONS['critical-care-visitor'],
  'cancer-care': JOURNEY_BATCH4_EXPLANATIONS['cancer-care'],
  'neurology-neurosurgery': JOURNEY_BATCH4_EXPLANATIONS['neurology-neurosurgery'],
  stroke: JOURNEY_BATCH4_EXPLANATIONS.stroke,
  cardiology: JOURNEY_BATCH5_EXPLANATIONS.cardiology,
  respiratory: JOURNEY_BATCH5_EXPLANATIONS.respiratory,
  endoscopy: JOURNEY_BATCH5_EXPLANATIONS.endoscopy,
  'inpatient-admission': JOURNEY_BATCH6_EXPLANATIONS['inpatient-admission'],
  'discharge-recovery': JOURNEY_BATCH6_EXPLANATIONS['discharge-recovery'],
  orthopaedics: JOURNEY_BATCH6_EXPLANATIONS.orthopaedics,
  paediatrics: JOURNEY_BATCH7_EXPLANATIONS.paediatrics,
  renal: JOURNEY_BATCH7_EXPLANATIONS.renal,
  'mental-health': JOURNEY_BATCH7_EXPLANATIONS['mental-health'],
  'imaging-diagnostics': JOURNEY_BATCH8_EXPLANATIONS['imaging-diagnostics'],
  radiotherapy: JOURNEY_BATCH8_EXPLANATIONS.radiotherapy,
  chemotherapy: JOURNEY_BATCH8_EXPLANATIONS.chemotherapy,
});
const EXPLANATION_FIELDS = ['whatHappens', 'whyItMayHappen', 'whatTeamIsDoing', 'variationNote'];
const NEXT_STEP_FIELDS = ['title', 'description', 'when'];

function row(path, sourceText, originalText = '') {
  return {
    id: `${JOURNEY_EXPLANATION_NAMESPACE}:${path}`,
    contentArea: CONTENT_AREA,
    namespace: JOURNEY_EXPLANATION_NAMESPACE,
    path,
    sourceText: String(sourceText || ''),
    originalText: String(originalText || ''),
  };
}

export function buildJourneyExplanationTranslationRows(locale) {
  const language = String(locale || '').toLowerCase().split('-')[0];
  const rows = [];

  for (const [journeyId, stages] of Object.entries(SOURCES)) {
    for (const [stageId, stageSource] of Object.entries(stages)) {
      const source = stageSource?.explanation || stageSource || {};
      const translated = getJourneyExplanationTranslation(language, journeyId, stageId) || {};
      for (const field of EXPLANATION_FIELDS) {
        rows.push(row(`${journeyId}.${stageId}.${field}`, source[field], translated[field]));
      }
      for (const sourceStep of source.nextSteps || []) {
        const translatedStep = (translated.nextSteps || []).find((item) => item?.id === sourceStep?.id) || {};
        for (const field of NEXT_STEP_FIELDS) {
          if (!sourceStep?.[field] && !translatedStep?.[field]) continue;
          rows.push(row(`${journeyId}.${stageId}.nextSteps.${sourceStep.id}.${field}`, sourceStep?.[field], translatedStep?.[field]));
        }
      }
    }
  }

  return rows;
}
